import React from "react";

import { IModalContext } from "./types";

export const ModalContext = React.createContext({} as IModalContext);

export function useModalContext() {
  const context = React.useContext(ModalContext);

  if (!context) {
    throw new Error("useModalContext must be inside ModalProvider");
  }

  return context;
}
